import { styled } from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #383838;
  border-radius: 30px;
  width: 561px;
  height: 45px;
  padding-left: 12px;
  margin-right: 24px;

  input {
    border: none;
    outline: none;
    width: 90%;
    font-size: 16px;
  }
`;
